const tr = document.querySelectorAll('tr[data-href]');
tr.forEach(function (el) {
	el.onclick = function (e) {
		const clickedElement = e.currentTarget;
		const href = clickedElement.dataset.href;
		location.href = href;
	}
});

const footerMembershipBtnSticky = () => {
	const classNames = {
		show: 'show',
		fixed: 'fix',
	};
	const elms = {
		btn: document.getElementById('membershipBtn'),
		clone: {},
	};
	if (!elms.btn) {
		return false;
	}
	elms.clone.static = _makeClone();
	elms.clone.fixed = _makeClone();
	elms.clone.fixed.classList.add(classNames.fixed);
	elms.btn.classList.add(classNames.fixed);
	const _sticky = () => {
		const staticPos = elms.clone.static.getBoundingClientRect().top;
		const fixedPos = elms.clone.fixed.getBoundingClientRect().top;
		if (staticPos < fixedPos) {
			if (elms.btn.classList.contains(classNames.fixed)) {
				elms.btn.classList.remove(classNames.fixed);
			}
		} else {
			if (!elms.btn.classList.contains(classNames.fixed)) {
				elms.btn.classList.add(classNames.fixed);
			}
		}

		if (document.scrollingElement.scrollTop > window.innerHeight / 2) {
			if (!elms.btn.classList.contains(classNames.show)) {
				elms.btn.classList.add(classNames.show);
			}
		} else {
			if (elms.btn.classList.contains(classNames.show)) {
				elms.btn.classList.remove(classNames.show);
			}
		}
	};
	window.addEventListener('load', _sticky, false);
	window.addEventListener('scroll', _sticky, false);

	function _makeClone() {
		const clone = elms.btn.cloneNode(true);
		clone.id = '';
		clone.style.opacity = '0';
		clone.style.zIndex = -1;
		clone.style.pointerEvents = 'none';
		elms.btn.insertAdjacentElement('afterend', clone);
		return clone;
	};
};

footerMembershipBtnSticky();

//フッターバナー　リアルタイムランダム入れ替え
const BNR_ORDER_TIME = 10000;
const orderItems = document.querySelectorAll('.promotionOrderItem');
const promoitonOrder = () => {
	if (orderItems.length === 0) {
		return false;
	}
	const nums = arrayShuffle([...Array(orderItems.length)].map((_, i) => i + 1));

	orderItems.forEach((el, i) => {
		el.style.order = nums[i];
	});
};

setInterval(promoitonOrder, BNR_ORDER_TIME);

function arrayShuffle(array) {
	for (let i = (array.length - 1); 0 < i; i--) {
		let r = Math.floor(Math.random() * (i + 1));
		let tmp = array[i];
		array[i] = array[r];
		array[r] = tmp;
	}
	return array;
}

(function () {
	const mScrollIcon = document.getElementById('memberPageScrollIcon');
	if (!mScrollIcon) {
		return false;
	}
	const _f = () => {
		if (document.scrollingElement.scrollTop > 0) {
			if (!mScrollIcon.classList.contains('hide')) {
				mScrollIcon.classList.add('hide');
			}
		} else {
			if (mScrollIcon.classList.contains('hide')) {
				mScrollIcon.classList.remove('hide');
			}
		}
	};
	window.addEventListener('load', _f);
	window.addEventListener('scroll', _f);
})();
